<!--
 * @Author: '李志远' '506642370@qq.com'
 * @Date: 2024-01-30 12:26:33
 * @LastEditors: '李志远' '506642370@qq.com'
 * @LastEditTime: 2024-02-01 11:33:32
 * @FilePath: \buyer_vue\src\views\common\mall-header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
/* 创建者 孙猛(2020.10.58) 修改 ：代码报错（2018.2.7） 修改：优化搜索框
魏强(2018.2.25) */
<template>
  <div
    class="header-wrap"
    id="aaa"
  >
    <header
      class="public-head-layout wrapper"
      style="width: 1226px; margin: 0px auto"
    >
      <!--LOGO-->
      <div class="site-logo index_logo">
        <router-link to="index">
          <img
            src="./../../../static/tyjf.png"
            class="pngFix"
            style="width: 68px; height: 68px"
          />
        </router-link>
      </div>
      <nav class="public-nav-layout">
        <!--分类树结束-->
        <ul class="site-menu">
          <li
            class="site-menu-li mr54"
            :class="currentNavIndex == index ? 'current-nav' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @mouseenter="mouseEnter(item.id)"
            @click="navHandle(index, item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </nav>
      <!--搜索-->
      <div class="head-search-bar">
        <el-input
          v-model="keywords"
          class="input-with-select"
        >
          <el-select
            class="head-search-select"
            v-model="searchType"
            @change="changeSearch"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              label="商品"
              value="goods"
            ></el-option>
            <el-option
              label="店铺"
              value="shop"
            ></el-option>
          </el-select>

          >
          <div
            slot="append"
            style="width: 60px"
          >
            <i
              class="ivu-icon ivu-icon-ios-search"
              style="font-size: 24px; margin-left: 20px; color: #fff"
              @click="searchBtn"
            ></i>
          </div>
        </el-input>
      </div>
      <div
        class="shop-car"
        @click="toCart()"
      >
        <i
          class="ivu-icon ivu-icon-ios-cart"
          style="font-size: 24px;color: #EC671A"
        ></i>
        <span>购物车</span>
        <span class="goods-num">{{ cartNums }}</span>
      </div>
    </header>
    <!-- @mouseleave="mouseOut" -->
    <div
      v-show="isShow"
      class="nav-hover-box"
      @mouseleave="mouseOut"
    >
      <!-- 商品分类 -->
      <categoryMenu
        v-if="isShow && currentNavId == 0"
        :catTree="catTree"
      ></categoryMenu>
      <!-- 自营优品 -->
      <navCommon
        v-show="isShow && currentNavId == 1"
        :menuList="selfList"
        :currentNavIndex="1"
      ></navCommon>
      <!-- 网店商家 -->
      <navCommon
        v-if="isShow && currentNavId == 2"
        :menuList="onlineList"
        :currentNavIndex="2"
      ></navCommon>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getSuggestGoodsList, getCatList, pcIndexHome } from "api/home";
import { debounce, randomString } from "utils/tool";
import categoryMenu from "views/common/category-menu.vue";
import navCommon from "views/common/navCommon.vue";
import { Input, Select, Option, Button } from "element-ui";
export default {
  created() {},
  data() {
    return {
      isShow: false,
      navList: [
        {
          id: 0,
          name: "首页",
          path: "/home",
        },
        {
          id: 1,
          name: "自营店铺",
          path: "",
        },
        {
          id: 2,
          name: "网店商家",
          path: "",
        },
        {
          id: 3,
          name: "现金券专区",
          path: "",
        },
      ],
      selfList: [
        {
          icon: require("../../assets/images/nav-icon/self-shop/1.png"),
          name: "自营优品",
          path: "/shop?tab=2&store_id=1",
        },
        {
          icon: require("../../assets/images/nav-icon/self-shop/2.png"),
          name: "自营积分专区",
          path: "/recommend-goods?type=8",
        },
        {
          icon: require("../../assets/images/nav-icon/self-shop/3.png"),
          name: "自营限时秒杀专区",
          path:
            process.env.NODE_ENV == "production"
              ? "/shop?tab=2&store_id=9046&pid=0&acid=83389"
              : "/shop?tab=2&store_id=158&acid=0",
        },
      ],
      onlineList: [
        {
          icon: require("../../assets/images/nav-icon/online-shop/1.png"),
          name: "企业店",
          path: "/common-store?storeType=2",
        },
        {
          icon: require("../../assets/images/nav-icon/online-shop/2.png"),
          name: "金牌店",
          path: "/common-store?storeType=4",
        },
        {
          icon: require("../../assets/images/nav-icon/online-shop/3.png"),
          name: "银牌店",
          path: "/common-store?storeType=5",
        },
        {
          icon: require("../../assets/images/nav-icon/online-shop/4.png"),
          name: "个体店",
          path: "/common-store?storeType=1",
        },
        {
          icon: require("../../assets/images/nav-icon/online-shop/5.png"),
          name: "同城商家",
          path: "/same-city-businesses",
        },
        {
          icon: require("../../assets/images/nav-icon/online-shop/6.png"),
          name: "农特生鲜",
          path: "/fresh-agricultural",
        },
      ],
      promptFlag: false,
      keywords: "",
      suggestions: [],
      suggestGoodsList: [],
      searchType: "goods",
      searchTitle: "请输入您要搜索的商品关键字",
      currentNavIndex: 0,
      catTree: [],
      catShow: true, // 根据当前页是否是首页判断商品分类是否显示
      showMore: false, //是否显示更多分类
      origin_tree: [], //初始的导航数据
      currentNavId: 0,
    };
  },
  watch: {
    $route(to, from) {
      // this.setCatShow(to.path);
    },
  },
  components: {
    categoryMenu,
    navCommon,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Option,
  },
  computed: {
    ...mapGetters(["sid", "cartNums"]),
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
  },
  created() {
    // this.fetchPcHomeData();
    if (sessionStorage.getItem("currentNavIndex")) {
      this.currentNavIndex = Number(sessionStorage.getItem("currentNavIndex"));
    }
    this.fetchCatList();
    this.setCatShow(this.$route.path);
    //搜索
    this.$watch(
      "keywords",
      debounce((newQuery) => {
        this.search(newQuery);
        this.$emit("keywords", newQuery);
      }, 500)
    );
  },
  methods: {
    toCart() {
      if(this.isLogin) {
        window.open("/shopping-cart");
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，请先登录后进去购物车！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    },
    fetchPcHomeData() {
      pcIndexHome().then((json) => {
        if (json.resCode == 1) {
          let data = json.data;
          this.selfShopList = data.selfOwnedBrandPlazaAdvertisementDTO.advList;
          this.selfShopList.forEach((item, index) => {
            if (item.aid == 1224) {
              this.selfList[index].path = item.url;
            } else if (item.aid == 1226) {
              this.selfList[index].path = item.url;
            } else {
              this.selfList[index].path = item.url;
            }
          });
        } else {
          console.log("首页数据错误");
        }
      });
    },
    fetchCatList() {
      getCatList({ categoryId: 0 }).then((json) => {
        if (json.resCode == 1) {
          let catTree = json.data;
          catTree = catTree.filter((cat) => cat.children.length);
          this.origin_tree = catTree;
          if (catTree.length > 13) {
            catTree = catTree.slice(0, 13);
          }
          this.catTree = catTree;
        }
      });
    },
    // 点击导航
    navHandle(index, item) {
      this.currentNavIndex = index;
      sessionStorage.setItem("currentNavIndex", this.currentNavIndex);
      if (index == 0) {
        this.$router.push("/index");
      } else if (index == 3) {
        let text = this.$router.resolve({
          path: "/recommend-goods?type=4",
        });
        window.open(text.href, "_blank");
      }
    },
    setCatShow(path) {
      console.log(path, "***********************");
    },
    mouseEnter(id) {
      this.currentNavId = id;
      this.isShow = true;
    },
    mouseOut(id) {
      this.isShow = false;
    },
    searchSuggest: function (item) {
      this.keywords = item;
      this.searchBtn();
      this.hiddenPrompt();
    },
    showPrompt: function () {
      if (this.searchType == "goods") {
        if (
          this.keywords &&
          this.suggestGoodsList &&
          this.suggestGoodsList.length
        ) {
          this.promptFlag = true;
        }
        if (this.keywords && this.suggestGoodsList.length == 0) {
          this.promptFlag = true;
          this.search();
        }
      }
    },
    hiddenPrompt: function () {
      this.promptFlag = false;
    },
    search: function (event) {
      if (this.searchType == "goods") {
        let _params = { namekeyword: event };
        getSuggestGoodsList(_params).then((res) => {
          if (res.resCode == 1) {
            this.suggestGoodsList = res.data;
            if (this.suggestGoodsList && this.suggestGoodsList.length) {
              this.promptFlag = true;
            }
          }
        });
      }
    },
    changeSearch(type) {
      this.promptFlag = false;
      this.searchType = type;
      this.searchTitle =
        type === "goods"
          ? "请输入您要搜索的商品关键字"
          : "请输入您要搜索的店铺关键字";
    },
    searchBtn() {
      this.promptFlag = false;
      let keywords = this.keywords;
      if (!keywords) {
        this.$Message.destroy();
        this.$Message.info("请输入关键字");
        return false;
      }
      //路由不更新，无法触发搜索方法
      let _params = { keywords: keywords, goodsType: this.goodsType };
      if (this.$route.query.keywords === this.keywords) {
        _params.page = randomString(25);
      }
      let url = { path: "/" + this.searchType + "-list", query: _params };

      if (
        this.$route.path == "/supply-chain-list" &&
        this.searchType == "goods"
      ) {
        url = {
          path: "/supply-chain-list",
          query: {
            keywords: keywords,
            goodsType: this.goodsType,
            source_flag: "2",
          },
        };
      }
      if (this.$route.path == "/first-buy-list" && this.searchType == "goods") {
        url = {
          path: "/first-buy-list",
          query: {
            keywords: keywords,
            goodsType: this.goodsType,
            source_flag: "4",
          },
        };
      }
      let vouchers = this.$route.query.vouchers_status;
      if (vouchers != undefined) {
        Object.assign(url.query, { vouchers_status: vouchers });
      }
      this.$router.push(url);
    },
    handleKeyup(e) {
      if (e && e.keyCode == 13) {
        this.searchBtn();
      }
    },
  },
};
</script>
<style scoped lang="less">
.current-nav {
  color: #000 !important;
}
.cart-list {
  max-height: 267px;
  overflow-y: auto;
}
.search-form .auto-input-wrap {
  width: 64%;
  display: block;
}
#aaa .ivu-input {
  border: 10px !important;
}
.my-cart {
  z-index: 101;
}
.cart-list {
  z-index: 999;
  .item {
    width: 98%;
    height: 66px;
    clear: both;
    margin-left: 2%;
    border-bottom: 1px dotted #ddd;
    position: relative;
    z-index: 1;
    img,
    span {
      background-color: transparent;
      border: 0;
      position: absolute;
      z-index: 1;
    }
    img {
      top: 8px;
      left: 8px;
      width: 48px;
      height: 48px;
      cursor: pointer;
    }
    .name {
      line-height: 16px;
      background-color: transparent;
      text-align: left;
      width: 180px;
      height: 32px;
      padding: 0;
      top: 8px;
      left: 64px;
      color: #333;
      cursor: pointer;
    }
    .price {
      text-align: right;
      width: 80px;
      height: 16px;
      top: 6px;
      right: 12px;
      color: #666;
    }
    .delete {
      width: 32px;
      top: 22px;
      right: 10px;
      color: #005ea6;
      cursor: pointer;
    }
  }

  .checkout {
    background-color: #f0f0f0;
    text-align: right;
    padding: 8px;
    overflow: hidden;
    cursor: pointer;
    span {
      display: block;
      float: right;
      clear: both;
      line-height: 20px;
      color: #fff;
      background-color: #d93600;
      padding: 4px 8px;
      margin-top: 4px;
      border-radius: 4px;
    }
  }
}
.shop-car {
  width: 110px;
  height: 36px;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #ec671a;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;
  padding: 0 12px;
  box-sizing: border-box;
  color: #ec671a;
  cursor: pointer;
  .goods-num {
    color: #fff;
    background: #d93600;
    font-size: 12px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    text-align: center;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// mall-header.vue?1c7663be